export default function getRequest(url, timeout) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.timeout = timeout || 30000
    xhr.onload = (e) => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.response)
        } else {
          reject(xhr.statusText)
        }
      }
    }
    xhr.onerror = (e) => {
      reject(xhr.statusText)
    }
    xhr.ontimeout = (e) => {
      reject('Request timeout')
    }
    xhr.send(null)
  })
}


// WEBPACK FOOTER //
// ./src/helpers/getRequest.js